var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lyformitem"},[_c('label',{style:({ width: (_vm.lw ? _vm.lw : 5) + 'em' })},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{style:({ width: 'calc(100% - ' + (_vm.lw ? _vm.lw : 5) + 'em' })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b8c6c57","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/lyFormItem.vue
// module id = null
// module chunks = 